import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes, FaBars } from 'react-icons/fa';

export default function Navigation() {
	const [open, setOpen] = useState(false);
	const handleClick = () => setOpen(!open);

	return (
		<div className='navigation-menu'>
			<div className='logo'>
				<Link to='/'>
					<img src='assets/giordanos_logo-red.svg' alt='' />
				</Link>
			</div>
			<nav>
				<ul className={open ? 'navbar active' : 'navbar'}>
					<li>
						<Link to='/' onClick={handleClick}>
							Home
						</Link>
					</li>
					<li>
						<Link to='/menu' onClick={handleClick}>
							Menu
						</Link>
					</li>
					<li>
						<Link to='/locations' onClick={handleClick}>
							Locations
						</Link>
					</li>
				</ul>
			</nav>
			<div onClick={handleClick} className='hamburger'>
				<div>{open ? <FaTimes /> : <FaBars />}</div>
			</div>
			<div className='desktop-menu'>
				<ul>
					<li>
						<Link to='/'>Home</Link>
					</li>
					<li>
						<Link to='/menu'>Menu</Link>
					</li>
					<li>
						<Link to='/locations'>Locations</Link>
					</li>
				</ul>
			</div>
		</div>
	);
}
